export const environment = {
  production: false,
  apiUrl: 'https://edge-legal.dev.falconsystem.com/api/v1'
};
